import { useSyncExternalStore } from 'react';
import { lazyComponent } from '@/app/lazyWithPreload';
import { installBannerDue, installSupport, subscribeToInstall } from '@/pwa/install';

/**
 * The install offer's code is fetched only once the offer is due (#577
 * follow-up for batch 2026-10-07c): it shows after three sessions or two
 * days, and on a browser that can install at all, so most first paints never
 * need it. The same two checks as `InstallPrompt` decide; it re-checks the
 * rest (snackbar, update, version skew) itself. Capturing the browser's
 * `beforeinstallprompt` stays eager, in `main.tsx`. The chunk is prefetched at
 * idle (`prefetch.ts`), so the strip appears in the same frame as before.
 */
export const InstallPrompt = lazyComponent(() => import('./InstallPrompt'), 'InstallPrompt');

export function InstallPromptGate() {
  const support = useSyncExternalStore(subscribeToInstall, installSupport, installSupport);
  const due = useSyncExternalStore(subscribeToInstall, () => installBannerDue(), () => false);
  if (!due || (support !== 'prompt' && support !== 'ios')) return null;
  return <InstallPrompt />;
}
